import { combineReducers } from "redux";
import { user } from "./reducers"

const reducers = combineReducers({ user })

export default reducers;
